module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": ""
    }
  }, [_c('main', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-container', {
    class: {
      'error': _vm.hasErrors
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "name",
      "label": "Username",
      "required": "",
      "dark": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Email",
      "required": "",
      "dark": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Password",
      "required": "",
      "dark": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "label": "Confirm Password",
      "required": "",
      "dark": ""
    },
    model: {
      value: (_vm.password_confirmation),
      callback: function($$v) {
        _vm.password_confirmation = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password_confirmation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_vm._v("\n                          Register\n                        ")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-xs-right"
  }, [_vm._v("Already Signed Up? "), _c('router-link', {
    staticClass: "success--text",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.hasErrors) ? _c('div', {
    staticClass: "error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', [_vm._v(_vm._s(error))])
  })) : _vm._e()], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc20cb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Register.vue
// module id = 221
// module chunks = 1